import React from "react";
import { cn } from "../utils/style";

function SelectInput({
  children,
  label,
  id,
  name,
  get,
  set,
  disabled,
  required,
  className,
}) {
  return (
    <div className={cn("space-y-2", className)}>
      <label
        htmlFor={id}
        className="block text-[11px] font-black uppercase tracking-wider text-slate-500 px-1 ms-1"
      >
        {label}{" "}
        {required && (
          <span className="text-red-500" aria-label="Required">
            *
          </span>
        )}
      </label>
      <div className="relative group">
        <select
          id={id}
          name={name}
          disabled={disabled}
          className={cn(
            "block w-full rounded-xl border-slate-200 bg-slate-50/50 py-3 text-sm font-bold text-slate-900 transition-all duration-300 shadow-sm",
            "ltr:ps-4 ltr:pe-10 rtl:ps-10 rtl:pe-4",
            "focus:border-primary-500 focus:bg-white focus:ring-4 focus:ring-primary-500/10 focus:shadow-md outline-none appearance-none",
            "disabled:opacity-50 disabled:bg-slate-100 disabled:cursor-not-allowed",
          )}
          value={get || ""}
          required={required || false}
          onChange={(e) => set(e.target.value)}
        >
          {children}
        </select>
        <div className="pointer-events-none absolute inset-y-0 ltr:right-0 rtl:left-0 flex items-center px-4 text-slate-400 transition-colors group-focus-within:text-primary-500">
          <svg className="h-4 w-4 fill-current" viewBox="0 0 20 20">
            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default SelectInput;
